import { createColumnHelper } from "@tanstack/react-table";

import type { Bundle } from "@/types";
import { Badge } from "@/ui/Badge";

const columnHelper = createColumnHelper<Bundle>();

export function getBundlesTableColumns() {
  const columns = [
    columnHelper.accessor("name", {
      header: "Bundle Name",
      cell: (info) => (
        <span title={info.getValue()} className="block max-w-64 truncate">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("type", {
      header: "Type",
      cell: (info) => {
        const type = info.getValue();
        return (
          <Badge
            text={type === "course" ? "Course" : "Training"}
            className={
              type === "course"
                ? "bg-purple-100 text-purple-800"
                : "bg-orange-100 text-orange-800"
            }
          />
        );
      },
    }),
    columnHelper.display({
      id: "materialCount",
      header: "Materials",
      cell: (info) => {
        const materials = info.row.original.materials ?? [];
        return <span>{materials.length}</span>;
      },
    }),
  ];

  return columns;
}
